import React, { useEffect, useState } from 'react';
import { Clock, Lock, Zap, ShieldCheck, CreditCard, Star } from 'lucide-react';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-189">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        {/* Countdown */}
        <div className="text-center mb-10" data-id="element-191">
          <div className="inline-flex flex-col items-center justify-center p-5 md:p-6 bg-white rounded-2xl border border-red-100 mb-2 w-full" data-id="element-192">
            <div className="flex items-center justify-center text-brand-red font-bold text-xs md:text-sm mb-3 text-center uppercase tracking-wider" data-id="element-193">
              <Clock className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-194" />
              <span data-id="element-195">PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO</span>
            </div>
            <div className="text-3xl md:text-5xl font-mono font-bold text-[#1A1A1A] mb-3 tracking-tight" data-id="element-196">
              {String(timeLeft.hours).padStart(2, '0')} HS :{' '}
              {String(timeLeft.minutes).padStart(2, '0')} MIN :{' '}
              {String(timeLeft.seconds).padStart(2, '0')} SEG
            </div>
            <p className="text-brand-red font-medium text-sm flex items-center" data-id="element-197">
              <span className="w-2 h-2 bg-brand-red rounded-full mr-2 animate-pulse" data-id="element-198"></span>
              El precio sube cuando termina el contador
            </p>
          </div>
        </div>

        {/* Main Checkout Card */}
        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-sm border border-gray-100" data-id="element-199">
          <div className="text-center mb-8 md:mb-10" data-id="element-200">
            <h2 className="font-sans font-black text-[#1A1A1A] tracking-[-0.02em] text-3xl md:text-5xl mb-4" data-id="element-201">
              Elegí tu Pack:
            </h2>
            <p className="text-base md:text-lg text-gray-500 leading-relaxed max-w-md mx-auto" data-id="element-202">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          {/* Pack Profesional Option */}
          <button type="button" onClick={() => setSelected('pro')} className={`w-full text-left rounded-2xl p-5 md:p-6 mb-4 transition-all border-2 ${selected === 'pro' ? 'bg-[#FBF1EC] border-[#C76F4A]' : 'bg-white border-gray-200 hover:border-gray-300'}`} data-id="element-203">
            <div className="flex items-center gap-4" data-id="element-204">
              {/* Radio */}
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === 'pro' ? 'border-[#C76F4A]' : 'border-gray-300'}`} data-id="element-205">
                {selected === 'pro' && <div className="w-3 h-3 rounded-full bg-[#C76F4A]" data-id="element-206"></div>}
              </div>

              {/* Title & subtitle */}
              <div className="flex-1 min-w-0" data-id="element-207">
                <h3 className="font-sans font-black text-[#1A1A1A] text-base md:text-xl tracking-tight leading-tight flex items-center gap-2" data-id="element-208">
                  <span data-id="element-209">📘</span>
                  <span data-id="element-210">PACK PROFESIONAL</span>
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-211">12 Tomos + 6 Bonus</p>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-212">
                <p className="text-sm text-gray-400 line-through leading-none" data-id="element-213">
                  $29.990
                </p>
                <p className="text-2xl md:text-3xl font-black text-[#1A1A1A] tracking-tight mt-1" data-id="element-214">
                  $18.990
                </p>
              </div>
            </div>
          </button>

          {/* Megapack Elite Option */}
          <button type="button" onClick={() => setSelected('elite')} className={`w-full text-left rounded-2xl p-5 md:p-6 mb-8 transition-all border-2 ${selected === 'elite' ? 'bg-[#FBF1EC] border-[#C76F4A]' : 'bg-white border-gray-200 hover:border-gray-300'}`} data-id="element-215">
            <div className="flex items-start gap-4" data-id="element-216">
              {/* Radio */}
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-1 ${selected === 'elite' ? 'border-[#C76F4A]' : 'border-gray-300'}`} data-id="element-217">
                {selected === 'elite' && <div className="w-3 h-3 rounded-full bg-[#C76F4A]" data-id="element-218"></div>}
              </div>

              {/* Content + Price column */}
              <div className="flex-1 min-w-0" data-id="element-219">
                <div className="flex items-start justify-between gap-3 mb-3" data-id="element-220">
                  <h3 className="font-sans font-black text-[#1A1A1A] text-base md:text-xl tracking-tight leading-tight flex items-center gap-2" data-id="element-221">
                    <span data-id="element-222">🏆</span>
                    <span data-id="element-223">MEGAPACK ÉLITE</span>
                  </h3>
                  <div className="text-right flex-shrink-0" data-id="element-224">
                    <p className="text-sm text-gray-400 line-through leading-none" data-id="element-225">
                      $49.990
                    </p>
                    <p className="text-2xl md:text-3xl font-black text-[#C76F4A] tracking-tight mt-1" data-id="element-226">
                      $27.990
                    </p>
                  </div>
                </div>

                {/* Badges */}
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-227">
                  <span className="inline-flex items-center px-3 py-1 bg-yellow-400 text-[#1A1A1A] rounded-full text-[10px] md:text-xs font-extrabold uppercase tracking-wider" data-id="element-228">
                    <Star className="w-3 h-3 mr-1 fill-current" data-id="element-229" /> MÁS ELEGIDO
                  </span>
                  <span className="inline-flex items-center px-3 py-1 bg-[#C76F4A]/15 text-[#C76F4A] rounded-full text-[10px] md:text-xs font-extrabold uppercase tracking-wider" data-id="element-230">
                    AHORRÁS $10.000
                  </span>
                </div>

                <p className="text-sm text-gray-500" data-id="element-231">
                  12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
                </p>
              </div>
            </div>
          </button>

          {/* Main CTA */}
          <a href={selected === 'elite' ? 'https://profelisto.com.ar/checkouts/cn/hWNCfEf2EpMcDV2HF8AtVETC/es-ar?_r=AQAB8cz7J00CTnlWIMQdPpw9mbdeY1GnMscrQF4yShxZqJ0' : 'https://profelisto.com.ar/checkouts/cn/hWNCfEebHfPuTWXQgXjQp19e/es-ar?_r=AQABR5QdIyiituDqhUbD2yGtuzS2E-BTv3p_SYNhKngC0xk'} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-[#C76F4A] hover:bg-[#B05C3A] transition-colors text-white font-bold text-base md:text-lg py-5 md:py-6 rounded-2xl shadow-xl shadow-[#C76F4A]/30 mb-6" data-id="element-232">
            {selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE →' : 'ELEGIR PACK PROFESIONAL →'}
          </a>

          <p className="text-center text-sm md:text-base italic text-gray-400 mb-2" data-id="element-233">
            La opción más elegida por profesores de italiano argentinos.
          </p>
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 gap-y-5 gap-x-4 mt-10 md:mt-12 px-2" data-id="element-234">
          <div className="flex items-center text-sm md:text-base text-gray-300" data-id="element-235">
            <Lock className="w-5 h-5 mr-2.5 flex-shrink-0" data-id="element-236" />
            <span className="text-gray-400" data-id="element-237">Pago seguro</span>
          </div>
          <div className="flex items-center text-sm md:text-base text-gray-300" data-id="element-238">
            <Zap className="w-5 h-5 mr-2.5 flex-shrink-0 text-yellow-500" data-id="element-239" />
            <span className="text-gray-400" data-id="element-240">Acceso en 5 min</span>
          </div>
          <div className="flex items-center text-sm md:text-base text-gray-300" data-id="element-241">
            <ShieldCheck className="w-5 h-5 mr-2.5 flex-shrink-0 text-green-600" data-id="element-242" />
            <span className="text-gray-400" data-id="element-243">Garantía 7 días</span>
          </div>
          <div className="flex items-center text-sm md:text-base text-gray-300" data-id="element-244">
            <CreditCard className="w-5 h-5 mr-2.5 flex-shrink-0" data-id="element-245" />
            <span className="text-gray-400" data-id="element-246">Tarjeta · Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}